<template>
 <div class="help-fourth-page">
  <div class="help-fourth-page-img-holder">
    <div :class="lang === 'en' ? 'help-4-img-u-l-en' : 'help-4-img-u-l'">
    </div>
    <div :class="lang === 'en' ? 'help-4-img-u-r-en' : 'help-4-img-u-r'">
    </div>
  </div>
  <div class="help-text-content-fourth-upper" data-langname="lb_help_41">
  </div>
  <div class="help-text-content-fourth-lower" data-langname="lb_help_42">
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      lang: this.$route.query.lang,
    };
  }
}
</script>
